import React, { Component } from 'react';
import cx from 'classnames';
import { Field } from 'formik';
import get from 'lodash/get';
import { PriceComparison } from '../../../../../components/PriceComparison';
import { TextArea } from '../../../../../components/TextArea';
import { TextInput } from '../../../../../components/TextInput';
import { callAll } from '../../../../../utils/callAll';
import { toFloat } from '../../../../../utils/functions';
import { numberWithComma, formatKm } from '../../../../../utils/mask';
import { Buttons } from '../../../components/Buttons';
import { StepThreeFormStates, StepThreeFormProps } from '../../../utils/Type';
import { AveragePrice } from '../../services/AveragePrice';
import styles from './styles.module.css';

export const customInputComponent = ({ divClass, field, setChange, form, ...props }: any) => {
  const { touched, errors } = form;
  const { name, onBlur, onChange, value } = field;
  const normalizeFieldData = {
    name,
    value,
    onBlur,
    onChange,
    errorMessage: !!touched[name] && errors[name],
  };
  const errorsInput = cx({
    mb16: !touched[name] || (!errors[name] && !!touched[name]),
    mb8: !!touched[name] && errors[name],
  });

  return (
    <div className={errorsInput}>
      <TextInput {...normalizeFieldData} {...props} />
    </div>
  );
};

export const customTextAreaComponent = ({ divClass, field, ...props }: any) => {
  const normalizeFieldData = {
    name: field.name,
    onBlur: field.onBlur,
    onChange: field.onChange,
    errorMessage: !!props.form.touched[field.name] && props.form.errors[field.name],
  };
  const errorsInput = cx({
    mb16:
      !props.form.touched[field.name] ||
      (!props.form.errors[field.name] && !!props.form.touched[field.name]),
    mb8: !!props.form.touched[field.name] && props.form.errors[field.name],
  });
  return (
    <div className={errorsInput}>
      <TextArea {...normalizeFieldData} {...props} />
    </div>
  );
};

let timeout: any = null;

export class StepThreeForm extends Component<StepThreeFormProps, StepThreeFormStates> {
  state: StepThreeFormStates = {
    ready: false,
    loading: false,
    userPrice: 0,
    userPriceNotFormat: 0,
    prices: {
      priceFipe: 0,
      averagePrice: 0,
    },
  };
  updateChart = () => {
    const { modelId } = this.props;
    this.setState({ loading: true });
    AveragePrice.getPrices(modelId)
      .then(res => {
        this.setState({
          prices: {
            priceFipe: get(res, 'priceFipe', 0),
            averagePrice: get(res, 'averagePrice', 0),
          },
          ready: true,
          loading: false,
        });
      })
      .catch(error => error.response);
  };

  handleResetData = () => {
    this.setState({
      prices: {
        averagePrice: 0,
        priceFipe: 0,
      },
      ready: false,
      loading: false,
    });
    if (this.props.edit && this.props.changeOverlay) {
      this.props.changeOverlay(3);
    }
  };

  handleComparePrice = () => {
    if (!this.props.edit) {
      const { prices, ready, loading } = this.state;
      const { price } = this.props.values;
      return (
        <div className="mt32 pl4">
          {ready && <p className="fw6 f14 abbey ma0 ">Compare o preço deste modelo no mercado.</p>}
          <PriceComparison
            loading={loading}
            ready={ready}
            prices={prices}
            userValue={toFloat(price)}
          />
        </div>
      );
    }
    return null;
  };

  handleOnChange = (e: any) => {
    clearTimeout(timeout);

    if (!this.props.edit && e.target.value !== '') {
      timeout = setTimeout(this.updateChart, 600);
    }

    if (e.target.value === '') {
      this.handleResetData();
    }
  };

  render() {
    const {
      title,
      handleChange,
      handleSubmit,
      values,
      setIsDraft,
      setIsNotDraft,
      changeOverlay,
      edit,
      overlay,
      resetForm,
      isLoading,
    } = this.props;

    const kmClass = cx('w-100', styles.inputSmall);
    const priceClass = cx('mt16 w-100', styles.inputSmall);
    const textAreaStyle = cx('mt16 w-100', styles.textArea);
    const formClass = cx({
      'pt12 pt24-ns pb24 pb0-ns': !edit,
    });
    const secondEditClick = (e: any) => {
      e.stopPropagation();
      resetForm();
      if (changeOverlay) {
        changeOverlay(0);
      }
    };

    const config = {
      edit,
      firstClick: edit ? handleSubmit : setIsNotDraft,
      secondClick: edit ? secondEditClick : setIsDraft,
      firstText: edit ? 'SALVAR ALTERAÇÃO' : 'PRÓXIMO',
      secondText: edit ? 'CANCELAR EDIÇÃO' : 'SALVAR E SAIR',
    };

    return (
      <form onSubmit={handleSubmit} className={formClass}>
        <div className={kmClass}>
          <Field
            name="kilometers"
            id={title + 'kilometers'}
            labeltext="Km"
            value={formatKm(values.kilometers)}
            onChange={handleChange}
            mask={formatKm}
            component={customInputComponent}
            maxLength={7}
            iconleft="SvgIconKm"
          />
        </div>
        <div className={textAreaStyle}>
          <Field
            name="description"
            id={title + 'description'}
            title="Descrição"
            labeltext="Descricao"
            value={values.description}
            onChange={handleChange}
            component={customTextAreaComponent}
            maxLength={1000}
          />
        </div>
        <div className={priceClass}>
          <Field
            name="price"
            id={title + 'price'}
            labeltext="Preço*"
            value={numberWithComma(values.price)}
            onChange={callAll(handleChange, this.handleOnChange)}
            mask={numberWithComma}
            component={customInputComponent}
            maxLength={12}
            iconleft="SvgIconCurrency"
          />
        </div>

        {this.props.isAdmin && (
          <div className={styles.toggleContainer}>
            <Field
              name="isInAutoscarPlay"
              type="checkbox"
              component="input"
              checked={values.isInAutoscarPlay}
            />
            <span className={styles.toggleText}>Anúncio presente no AutoscarPlay</span>
          </div>
        )}

        {this.handleComparePrice()}
        <Buttons
          render={!edit || (edit && overlay === 3)}
          config={config}
          overlay={overlay}
          isSubmitting={isLoading}
          typeSecondButton={edit ? 'button' : 'submit'}
        />
      </form>
    );
  }
}
